// extracted by mini-css-extract-plugin
export default {"icon":"src-components-common-Arrow-index__icon--nnTw_"};